<template>
  <b-form-group
    :description="description"
    :label="label" label-cols="3" 
    label-size="sm"
    :invalid-feedback="invalidFeedback"
    :valid-feedback="validFeedback"
    :state="state"
  >
    <b-form-input :name="name" type="number"
        :value="value" size="sm" aria-multiline="" :min="min" :max="max"
        @input.native="$emit('input',$event.target.value)"
        :placeholder="placeholder" :state="state" trim>
    </b-form-input>
  </b-form-group>
</template>
<script>
export default {
  name: 'NumberInput',
  props: ['placeholder', 'label', 'name', 'value', 'min', 'max']
}
</script>